<template>
  <v-row class="align-items-end">
    <v-col cols="9" class="custom-col">
      <h3 class="chart-title">{{ title }}</h3>
      <div class="legend-wrapper" v-html="htmlLegend" />
      <BarChartMonth
        v-if="chartDatalabels.length <= 12"
        :month-datasets="monthDatasets"
        :chart-datalabels="chartDatalabels"
        @generated-legend="handleGeneratedLegend"
      />
      <div v-else class="month-chart-wrapper">
        <BarChartMonth
        :month-datasets="monthDatasets"
        :chart-datalabels="chartDatalabels"
        @generated-legend="handleGeneratedLegend"
        class="month-chart"
      />
      </div>
    </v-col>

    <v-col cols="3" class="custom-col">
      <BarChartYear :year-datasets="yearDatasets" />
    </v-col>
  </v-row>
</template>

<script>
import BarChartMonth from './BarChartMonth'
import BarChartYear from './BarChartYear'

export default {
  name: 'BarChartContainer',

  components: {
    BarChartMonth,
    BarChartYear
  },

  props: {
    monthDatasets: {
      type: Array,
      default: () => []
    },
    yearDatasets: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    chartDatalabels: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      htmlLegend: ''
    }
  },

  methods: {
    handleGeneratedLegend (html) {
      this.htmlLegend = html
    }
  }
}
</script>

<style>
.legend-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.legend-item {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 3rem;
  font-size: 13px;
  line-height: 21px;
  color: #6e6b7b;
}

.legend-item:last-child {
  margin-right: 0;
}

.legend-item__icon {
  margin-right: 8px;
  width: 9px;
  height: 9px;
  border-radius: 99px;
}

.custom-col {
  padding-top: 13px;
  padding-left: 26px;
}

.custom-col:first-child {
  border-right: 1px solid #ebe9f1;
}

.custom-col:last-child {
  padding-left: 8px;
}

.chart-title {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #5E5873;
  margin-bottom: 23px;
}

.month-chart-wrapper {
  overflow-x: scroll;
}

.month-chart {
  width: 68vw;
}
</style>
